import { ListItem, UnorderedList } from "@chakra-ui/react";

interface IncludesProps {
  cardFiles: { file_name: string }[];
}

const Includes = ({ cardFiles }: IncludesProps) => {
  return (
    <UnorderedList>
      <ListItem>Unlimited streaming</ListItem>
      <ListItem>WAV and MP3 Download</ListItem>
      <ListItem>Listen on the go with the Songcards mobile app</ListItem>
      <ListItem>First dibs on future Songcards</ListItem>
      <ListItem>Listing on your collectors page</ListItem>
      <ListItem>Proof Of Fan</ListItem>
      {cardFiles &&
        cardFiles.map((file, index) => (
          <ListItem key={index}>{file.file_name}</ListItem>
        ))}
    </UnorderedList>
  );
};

export default Includes;
